export const getDefaultCell = ({
	rowData,
	field,
	readOnly = false,
	DefaultCell,
	DefaultEditableCell,
}) =>
	!readOnly && rowData[`${field.id}Validation`]
		? DefaultEditableCell
		: DefaultCell;
